// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationTemplateRevisionId } from './HarvestOperationTemplateRevision';
import { operatorId } from './Operator';
import { z } from 'zod';
export const harvestOperationTemplateKpiId = (z.number());
export const harvestOperationTemplateKpi = z.object({
    id: harvestOperationTemplateKpiId,
    operation_template_id: harvestOperationTemplateRevisionId,
    code: z.string().nullable(),
    name: z.string(),
    formula: z.string(),
    result_unit: z.string().nullable(),
    result_display_unit: z.string().nullable(),
    display_group: z.string().nullable(),
    display_order: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const harvestOperationTemplateKpiInitializer = z.object({
    id: harvestOperationTemplateKpiId.optional(),
    operation_template_id: harvestOperationTemplateRevisionId,
    code: z.string().optional().nullable(),
    name: z.string(),
    formula: z.string(),
    result_unit: z.string().optional().nullable(),
    result_display_unit: z.string().optional().nullable(),
    display_group: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const harvestOperationTemplateKpiMutator = z.object({
    id: harvestOperationTemplateKpiId.optional(),
    operation_template_id: harvestOperationTemplateRevisionId.optional(),
    code: z.string().optional().nullable(),
    name: z.string().optional(),
    formula: z.string().optional(),
    result_unit: z.string().optional().nullable(),
    result_display_unit: z.string().optional().nullable(),
    display_group: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=HarvestOperationTemplateKpi.js.map